// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import navigate from './mixins/navigate'
import { initFacebookSdk } from './utilities/initFacebook'
import VueSweetalert2 from 'vue-sweetalert2'
import VueHead from 'vue-head'
import VueGtm from 'vue-gtm'
import VueSocialSharing from 'vue-social-sharing'
import VueMoment from 'vue-moment'
import VueMask from 'v-mask'
import moment from 'moment-timezone'
import vuetify from './plugins/vuetify'

import Components from '@roundupapp/component-library'

for (var k in Components) {
	if (!k.includes('config')) {
		Vue.component(k, Components[k])
	}
}

Vue.use(navigate)
Vue.use(moment)
Vue.use(VueSweetalert2)
Vue.use(VueMask)
Vue.use(VueHead)
Vue.use(VueMoment)
Vue.use(VueSocialSharing, {
	networks: {
		sms: `sms:?&body=@d @u`,
		email: `mailto:?&subject=@t&body=@d @u`
	}
})
Vue.use(VueGtm, {
	id: process.env.VUE_APP_GTM,
	// queryParams: {
	// 	// Add url query string when load gtm.js with GTM ID (optional)
	// 	gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
	// 	gtm_preview: 'env-4',
	// 	gtm_cookies_win: 'x'
	// },
	defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	debug: false, // Whether or not display console logs debugs (optional)
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
	vueRouter: router, // Pass the router instance to automatically sync with router (optional)
	// ignoredViews: ['homepage'], // Don't trigger events for specified router names (case insensitive) (optional)
	trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
})

Vue.config.productionTip = false

try {
	initFacebookSdk().then(startApp)
} catch {
	startApp()
}

function startApp() {
	new Vue({
		router,
		store,
		vuetify,
		render: (h) => h(App)
	}).$mount('#app')
}
